// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3n-IY","search":"Settings_search__6gyPc","filter":"Settings_filter__3qRAi"};